export default __webpack_public_path__ + "static/media/speakers__map.dbe6b7c0.png";